import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ScrBaseTabComponent } from 'src/app/components/base.component';
import { LeaseBilling } from 'src/app/models/lease.model';
import { Address } from 'src/app/services/address-book.service';
import { ConfigService } from 'src/app/services/config.service';
import { ShortCodesService } from 'src/app/services/shortcodes.service';
import { handleEnterKeyPress } from 'src/app/shared/common-events';
@Component({
  templateUrl: './edit-billing-details.component.html',
  styleUrls: ['./edit-billing-details.component.scss']
})
export class EditBillingDetailsComponent extends ScrBaseTabComponent implements OnInit {
  public scId: number;
  public model!: LeaseBilling;
  public loaded = false;
  public publicEmailDomains: string[] = [];

  constructor(
    private route: ActivatedRoute,
    private configService: ConfigService,
    private shortCodesService: ShortCodesService
  ) {
    super();

    this.tt = 'Edit Billing';
    this.routeElement = 'billingDetails';

    this.scId = this.route.snapshot.params.scId;
  }


  ngOnInit(): void {
    this.configService.getConfig().subscribe(cfg => {
      this.publicEmailDomains = cfg.publicEmailDomains;
    });
    this.subscriptions.push(this.route.params.subscribe({
      next: (params) => {
        this.log.trace('params are now ' + JSON.stringify(params));
        this.scId = params.scId;
        this.fetchBillingData();
      }
    }));
  }

  fetchBillingData(): void {

    this.observe(this.shortCodesService.getBillingData(this.scId), (res) => {
      if (res.leasedCodeDetail) {
        this.model = res.leasedCodeDetail;
      }
      if (!this.model.isInvoiceUpdate) {
        this.model.isInvoiceUpdate = false;
      }
      this.loaded = true;
      return false;
    });
  }

  override getObjectId(): string {
    return `${this.scId}`;
  }

  getRegionRequired(): boolean {
    return (
      this.model.billingCountry == 'us' || this.model.billingCountry == 'ca'
    );
  }

  next({ form }: NgForm): void {
    this.clearMessages();
    document.getElementById('application-form')?.classList.remove('presubmit');

    form.markAllAsTouched();
    for (const name in form.controls) {
      form.controls[name].markAsDirty();
    }
    if (form.invalid) {
      const firstError = document.querySelector(
        '.ng-invalid .ng-invalid'
      )?.parentElement;
      if (firstError) {
        firstError.scrollIntoView();
      }
    } else {
      this.observe(
        this.shortCodesService.patchEditBillingApplication(
          this.scId,
          this.model
        ),
        () => {
          window.setTimeout(() => this.cancel(), 0);
        }
      );
    }
  }

  cancel() {
    document.querySelector('a.active .btn')?.dispatchEvent(new Event('click'));
  }

  loadApplicantAddress(address: Address) {

    this.model.billingFirstName = address.firstName ? address.firstName : "";
    this.model.billingLastName = address.lastName ? address.lastName : "";
    this.model.billingAddress1 = address.address1 ? address.address1 : "";
    this.model.billingAddress2 = address.address2 ? address.address2 : "";
    this.model.billingCity = address.city ? address.city : "";
    this.model.billingCountry = address.country ? address.country : "";
    this.model.billingState = address.state ? address.state : "";
    this.model.billingZip = address.zip ? address.zip : "";
    this.model.billingPhone = address.phone ? address.phone : "";
    this.model.billingPhoneExtension = address.phoneExtension ? address.phoneExtension : "";

  }

  handleEnter(event: Event) {
    handleEnterKeyPress(event);
  }
}
